import styled from "@emotion/styled"
import WelfareBonusCard from "./components/WelfareBonusCard"
import BonusRewardsCard from "./components/BonusRewardsCard"
import Image from "@/components/base/Image"
import { css } from "@emotion/react"

const Root = styled.div`
    font-size: 12rem;
    background-color: #fff;
    flex: 1;
    position: relative;
    overflow: hidden;
    // user-select: none;
    // pointer-events: none;
`

export default function WalfarePage() {
    return (
        <Root>
            <WelfareBonusCard />
            <BonusRewardsCard />
            {/* <div
                css={css`
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    z-index: 1;
                    background-color: #ffffff9f;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                `}
            >
                <Image
                    css={css`
                        width: 200rem;
                        height: 200rem;
                        object-fit: contain;
                    `}
                    src="base_image/comingSoon.webp"
                />
            </div> */}
        </Root>
    )
}
